// src/pages/Dashboard/DashboardChartsContainer.jsx
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CartsCard from "./CartsCard/CartsCard";
import { http } from "../../../../clients/http/http.client";
import { HTTP_ENDPOINTS } from "../../../../clients/clients.constants"
import AlertsCard from "./AlertsDashboardCard/AlertsCard";
import {useSelector} from "react-redux";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import InventoryIcon from "@mui/icons-material/Inventory";
import SocketClient from "../../../../clients/socket.client";

const { ALERTS_CART_STATISTICS } = HTTP_ENDPOINTS;

const dashboardContainerStyles = {
  display: "flex",
  width: "100%",
  gap: "20px",
  ".storeHoursCard": {
    flex: 1,
  },
  ".alertsCard": {
    minWidth: "190px",
  },
};

// const siteIdStore = useSelector((state) => state.siteId);
//
// const buildSiteIdQueryParams = () => {
//   let params = new URLSearchParams();
//
//   if (siteIdStore.siteId) {
//     params.append('siteId', siteIdStore.siteId);
//   }
//
//   return params.toString() ? `?${params.toString()}` : '';
// };
//
// useEffect(() => {
//   setLoading(true);
//   const filters = buildSiteIdQueryParams();
//
//   http.client
//     .get(`${ALERTS_CART_STATISTICS}/${filters}`)
//     .then((response) => {
//       const data = response.map((cartStat) => {
//         if (cartStat.name === 'In use') {
//           cartStat.color = COLORS[0]
//         }
//
//         if (cartStat.name === 'Out of store') {
//           cartStat.color = COLORS[1]
//         }
//
//         if (cartStat.name === 'Carts zone') {
//           cartStat.color = COLORS[2]
//         }
//
//         return cartStat;
//       })
//
//       setCartsData(data);
//       setLoading(false);
//     })
//     .catch((err) => {
//       setError(err.message);
//       setLoading(false);
//     });
//
//   if (siteIdStore.siteId) {
//     socket.emit('setSiteId', { siteId: siteIdStore.siteId });
//   }
// }, [siteIdStore]);
//
// useEffect(() => {
//   socket.on('cartStatistics', (socketData) => {
//     const data = socketData.map((cartStat) => {
//       if (cartStat.name === 'In use') {
//         cartStat.color = COLORS[0]
//       }
//
//       if (cartStat.name === 'Out of store') {
//         cartStat.color = COLORS[1]
//       }
//
//       if (cartStat.name === 'Carts zone') {
//         cartStat.color = COLORS[2]
//       }
//
//       return cartStat;
//     });
//
//     setCartsData(data);
//   });
// }, []);

const CARTS_COLORS = [
  "#89D8C2", "#B6CFF1", "#E89585",
  "#32a852", "#328da8", "#3012de",
  "#e622ab"
];

const FIXTURES_COLORS = [
  "#89D8C2",
  "#B6CFF1",
  "#C56F57",
  "#E89585",
  "#9783DF",
];

const BACKROOM_MATERIAL_COLORS = [
  "#89D8C2",
  "#B6CFF1",
  "#C56F57",
  "#E89585",
  "#9783DF",
];

const ARRC_INVENTORY_COLORS = [
  "#89D8C2",
  "#B6CFF1",
  "#C56F57",
  "#FFD166",
  "#EF476F",
  "#8338EC",
  "#3A86FF"
];

const DashboardChartsContainer = () => {
  const [cartsData, setCartsData] = useState([]);
  const [fixturesData, setFixturesData] = useState([]);
  const [backroomData, setBackroomData] = useState([]);
  const [arrcData, setArrcData] = useState([]);
  const socket = SocketClient.getSocket();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const siteIdStore = useSelector((state) => state.siteId);

  const enrich = (arr, colors) => {
    const total = arr.find((s) => s.name === "Total")?.value || 1;
    return arr.map((stat, idx) => ({
      ...stat,
      color: colors[idx % colors.length],
      percentage: `${((stat.value / total) * 100).toFixed(1)}%`,
    }));
  };

  const buildSiteIdQueryParams = () => {
    let params = new URLSearchParams();

    if (siteIdStore.siteId) {
      params.append('siteId', siteIdStore.siteId);
    }

    return params.toString() ? `?${params.toString()}` : '';
  };

  useEffect(() => {
    const params = buildSiteIdQueryParams();
    setLoading(true);
    http.client
      .get(`${ALERTS_CART_STATISTICS}${params}`)
      .then((response) => {
        const { carts, fixtures, backroomMaterial, arrcInventory } = response;
        console.log(response);
        setCartsData(enrich(carts, CARTS_COLORS));
        setFixturesData(enrich(fixtures, FIXTURES_COLORS));
        setBackroomData(enrich(backroomMaterial, BACKROOM_MATERIAL_COLORS));
        setArrcData(enrich(arrcInventory, ARRC_INVENTORY_COLORS));
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));

    if (siteIdStore.siteId) {
      socket.emit('setSiteId', { siteId: siteIdStore.siteId });
    }
  }, [siteIdStore]);


  useEffect(() => {
    const handleStats = (socketData) => {
      console.log(socketData);
      setCartsData(enrich(socketData.carts, CARTS_COLORS));
      setFixturesData(enrich(socketData.fixtures, FIXTURES_COLORS));
      setBackroomData(enrich(socketData.backroomMaterial, BACKROOM_MATERIAL_COLORS));
      setArrcData(enrich(socketData.arrcInventory, ARRC_INVENTORY_COLORS));
    };

    socket.on('cartStatistics', handleStats);

    return () => {
      socket.off('cartStatistics', handleStats);
    };
  }, [socket]);

  return (
    <Box sx={dashboardContainerStyles}>
      <CartsCard
        icon={<ShoppingCartOutlinedIcon sx={{ color: "#1B3665" }} />}
        data={cartsData}
        loading={loading}
        mainValue={cartsData.find((d) => d.name === "Total")?.value || 0}
        mainLabel="Carts"
        popupLabel="Carts"
        subtitle="Total Carts"
        navigatePath="/asset-tracking?view=shopping-carts"
        colors={CARTS_COLORS}
      />
      <CartsCard
        icon={<CheckroomIcon sx={{ color: "#1B3665" }} />}
        data={fixturesData}
        loading={loading}
        mainValue={fixturesData.find((d) => d.name === "Total")?.value || 0}
        mainLabel="Fixtures"
        popupLabel="Fixtures"
        subtitle="Total Fixtures"
        navigatePath="/asset-tracking?view=fixtures"
        colors={FIXTURES_COLORS}
      />
      <CartsCard
        icon={<WarehouseIcon sx={{ color: "#1B3665" }} />}
        data={backroomData}
        loading={loading}
        mainValue={backroomData.find((d) => d.name === "Total")?.value || 0}
        mainLabel="Backroom Material"
        popupLabel="Material"
        subtitle="Total Backroom Material"
        navigatePath="/asset-tracking?view=backroom-material"
        colors={BACKROOM_MATERIAL_COLORS}
        maxContainerWidth={280}
        width={270}
      />
      <Box sx={{ marginLeft: "auto" }}>
        <CartsCard
          icon={<InventoryIcon sx={{ color: "#1B3665" }} />}
          data={arrcData}
          loading={loading}
          mainValue={arrcData.find((d) => d.name === "Total")?.value || 0}
          mainLabel="ARRC Inventory"
          popupLabel="Inventory"
          subtitle="Total ARRC Inventory"
          navigatePath="/asset-tracking?view=arrc-inventory"
          colors={ARRC_INVENTORY_COLORS}
          maxContainerWidth={280}
          width={270}
        />
      </Box>
      <AlertsCard />
    </Box>
  );
};

export default DashboardChartsContainer;
